import {
  Button,
  ButtonGroup,
  Divider,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'

import { useState } from 'react'

const SaveBackupCodes = ({ onConfirm, backupCodes }) => {
  const theme = useTheme()

  const actions = ['download', 'print', 'copy']
  const [userHasSavedCodes, setUserHasSavedCodes] = useState(false)

  const handleBackupCodeActions = (action) => {
    switch (action) {
      case 'download':
        const link = document.createElement('a')
        const file = new Blob([backupCodes.join('\n', backupCodes)], {
          type: 'text/plain',
        })
        link.href = URL.createObjectURL(file)
        link.download = 'backupCodes.txt'
        link.click()
        URL.revokeObjectURL(link.href)
        setUserHasSavedCodes(true)
        return
      case 'print':
        window.print()
        setUserHasSavedCodes(true)
        return
      case 'copy':
        navigator.clipboard.writeText(backupCodes)
        setUserHasSavedCodes(true)
        return
    }
  }

  return (
    <Stack
      sx={{
        gap: 4,
        direction: 'column',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Stack
        sx={{
          backgroundColor: theme.palette.background.default,
          gap: 2,
          direction: 'column',
          width: '100%',
          alignItems: 'center',
          p: 2,
          borderRadius: theme.shape.borderRadius + 'px',
        }}
      >
        <Stack
          sx={{
            gap: 2,
            direction: 'column',
            width: '100%',
            alignItems: 'center',
            p: 2,
          }}
        >
          {backupCodes.map((code, index) => {
            return (
              <Stack
                key={index}
                sx={{ width: '100%', gap: 2, alignItems: 'center' }}
              >
                <Typography
                  sx={{ width: '100%', textAlign: 'center' }}
                  variant="body2"
                >
                  {code}
                </Typography>
                {index < backupCodes.length - 1 && (
                  <Divider sx={{ width: '75%' }}></Divider>
                )}
              </Stack>
            )
          })}
        </Stack>

        <Stack displayPrint="none">
          <ButtonGroup>
            {actions.map((action) => {
              return (
                <Button
                  key={action}
                  variant="outlined"
                  color="primary"
                  onClick={() => handleBackupCodeActions(action)}
                >
                  {action}
                </Button>
              )
            })}
          </ButtonGroup>
        </Stack>
      </Stack>
      <Stack displayPrint="none">
        <Button
          variant="contained"
          color="primary"
          onClick={() => onConfirm()}
          disabled={!userHasSavedCodes}
        >
          I saved the backup codes
        </Button>
      </Stack>
    </Stack>
  )
}

export default SaveBackupCodes
